<script lang="ts">
  import { fn } from "../../../stores";
  import { TRichAlertButtonConfig, TRichAlertOptions } from "../../../utils/types";
  import Button from "../shared/inputs/button/Button.svelte";
  import { get } from "svelte/store";

  export let options: TRichAlertOptions;

  let title: string | undefined;
  let description: string | undefined;
  let actions: TRichAlertButtonConfig[] = [];
  const { close } = get(fn);

  $: if (options) {
    ({ title, description, actions = [] } = options);
  }
</script>

<div class="crtw-flex crtw-flex-col crtw-justify-center crtw-items-center">
  <div class="crtw-text-2xl crtw-uppercase crtw-text-black crtw-font-bold">
    {title}
  </div>

  <div class="crtw-text-base crtw-text-black crtw-text-center crtw-mb-1">
    {description}
  </div>
</div>

{#if actions?.length > 0}
  <div class="crtw-flex crtw-flex-col crtw-gap-2.5 crtw-w-full crtw-items-center">
    {#each actions || [] as action, index}
      {#if action?.onClick}
        <Button text={action.text} onClick={action.onClick} />
      {:else if action?.link}
        <a
          href={action?.link}
          class="crtw-flex crtw-justify-center crtw-items-center crtw-w-full crtw-h-[50px] crtw-cursor-pointer
           crtw-border-2 crtw-border-black crtw-rounded crtw-font-['Poppins'] crtw-text-base crtw-font-medium"
          >{action?.text}
        </a>
      {/if}
      {#if index !== actions.length - 1}
        <div class="crtw-w-full crtw-border-b-2 crtw-border-gray-400"></div>
      {/if}
    {/each}
  </div>
{:else}
  <Button text="Close" onClick={close} />
{/if}
